import React from 'react';
import classnames from 'classnames';
import { getNumberOfDotUnit, getValidDate } from '@gp/utils/common';
import { STEPPER_DATE_FORMAT_MAP } from '../../constants';

import type { IBaseProps } from '@home/types/common';
import type { ICalendarColCfgMapping } from '../../types';

interface ICalendarPanelHeaderProps extends IBaseProps {
  colCfgMapping?: ICalendarColCfgMapping;
  dateType?: ScheduledateTypes;
  currentTime?: string;
  dataList?: CommonCalendarDataTypes;
  getCalendarColMR?: (index: number) => number | string;
  onTimeLineScroll?: (e: any) => void;
}

const getCalendarPanelHeaderKey = (key?: string) => `dbg-calendar-panel-header__${key}`;

const getCalendarDateLabel = (dateType?: ScheduledateTypes, date?: string): string => {
  if (!dateType || !date) return '';
  const dataItemDateFormatted = getValidDate(date, STEPPER_DATE_FORMAT_MAP[dateType]);
  return dateType === 'quarter' && dataItemDateFormatted !== '-'
    ? dataItemDateFormatted?.replace('.', '.Q')
    : dataItemDateFormatted;
};

const getCalendarProjectsLabel = (len = 0): string => {
  const domainLabel = len > 1 ? 'Projects' : 'Project';
  return `${getNumberOfDotUnit(len)} ${domainLabel}`;
};

const CalendarPanelHeader: React.ForwardRefRenderFunction<HTMLDivElement, ICalendarPanelHeaderProps> = (props, ref) => {
  const {
    style,
    className,
    colCfgMapping,
    dateType = 'quarter',
    currentTime,
    dataList,
    getCalendarColMR,
    onTimeLineScroll,
    isSingLine,
  } = props;

  return (
    <div
      ref={ref}
      style={style}
      className={classnames('dbg-schedule-calendar-body-main-header', className, {
        'dbg-schedule-calendar-body-main-header-is-sing-line': isSingLine,
      })}
      onScroll={onTimeLineScroll}
    >
      <div className="dbg-schedule-calendar-body-main-box">
        {dataList?.map((dataItem, dataItemIdx) => {
          const { date: dataItemDate, list: dataItemList } = dataItem || {};
          const isCurrentTimeCol = dataItemDate === currentTime;
          const dataItemColCfg = colCfgMapping?.[dataItemDate];
          const { width: dataItemColWidth = 0, cardWidth: dataItemColCardWidth = 0 } = dataItemColCfg || {};

          return (
            <div
              key={getCalendarPanelHeaderKey(dataItemDate)}
              className={classnames('dbg-item-col', { 'current-time-col': isCurrentTimeCol })}
              style={{
                marginRight: getCalendarColMR?.(dataItemIdx),
                flex: `0, 0 ${dataItemColWidth}`,
                width: dataItemColWidth,
              }}
            >
              <div className="dbg-item-col-space" style={{ width: dataItemColCardWidth }}>
                <div className="dbg-item-col-box">
                  <div className="dbg-item-col-date">{getCalendarDateLabel(dateType, dataItemDate)}</div>
                  <div className="dbg-item-col-num">{getCalendarProjectsLabel(dataItemList?.length)}</div>
                  <div className="dbg-item-col-line">
                    <i></i>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(React.forwardRef(CalendarPanelHeader));
